import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  getErrorFromStorage,
  removeErrorFromStorage,
  setErrorFromStorage,
} from 'utils/error';

const initialState = () => ({ ...getErrorFromStorage() });

type ActionType = PayloadAction<ReturnType<typeof initialState>>;

const errorSlice = createSlice({
  name: 'error',
  initialState: initialState(),
  reducers: {
    setError: (state, action: ActionType) => {
      setErrorFromStorage(action.payload);
      return action.payload;
    },
    sendError: (state, action: ActionType) => state,
    sendNetworkError: (state, action: ActionType) => state,
    removeError: () => {
      removeErrorFromStorage();
      return {
        errorMessage: null,
        errorStack: null,
      };
    },
  },
});

const { actions, reducer } = errorSlice;

export const { setError, sendError, sendNetworkError, removeError } = actions;
export default reducer;
